<template>
  <q-card flat class="analysis-tab">
    <q-card-section class="bg-white fit content">
      <Dropdowns ref="drops" class="dropdowns" @filter-data="filterData" />
      <SubscriptionsRead ref="subs" @select="setSubsRowsIds" />
      <JournalsPublish ref="journals" @select="setJournalsRowsIds" />
      <Analysis :key="analysisKey" ref="analysis" :no-cards-text="noCardsText" class="analysis" @analyze="analyze" />
    </q-card-section>
  </q-card>
</template>

<script>
import * as apiTo from './api'
// Components
import Dropdowns from './components/dropdowns/Dropdowns'
import SubscriptionsRead from './components/SubscriptionsRead'
import JournalsPublish from './components/JournalsPublish'
import Analysis from './components/analysis/Analysis'

export default {
  components: {
    Dropdowns,
    SubscriptionsRead,
    JournalsPublish,
    Analysis
  },

  data: () => ({
    subsIds: [],
    articlesIds: [],
    noCardsText: 'Click analyze to output Read/Publish analysis',
    analysisKey: 1
  }),

  methods: {
    getJournalsWithIds(rows) {
      return rows.map(el => ({
        ...el,
        id: `${el.journal_name + el.print_identifier + el.online_identifier}`
      }))
    },

    setSubsRowsIds(rowsIds) {
      this.subsIds = rowsIds
      this.analysisKey++
    },

    setJournalsRowsIds(rowsIds) {
      this.articlesIds = rowsIds
      this.analysisKey++
    },

    filterData(payload) {
      this.$refs.subs.showLoading()
      this.$refs.journals.showLoading()
      apiTo.filterData(payload).then(({ data }) => {
        this.$refs.subs.setNewRows(data.result.subscription_periods)
        this.$refs.journals.setNewRows(this.getJournalsWithIds(data.result.journals))
      })
    },

    analyze() {
      if (!this.subsIds.length || !this.articlesIds.length) return
      apiTo
        .analyze({
          subscription_period_ids: this.subsIds,
          subscription_year: this.$refs.drops.getSubYear(),
          article_ids: this.articlesIds,
          article_year: this.$refs.drops.getArticleYear()
        })
        .then(({ data: { result: res } }) => {
          this.$refs.analysis.setData(res)
          /* Without the code below the ag-grid tables get an horizontal scroll */
          this.$nextTick(() => {
            this.$root.$emit('resize')
          })
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.analysis-tab {
  padding 20px
  background #E6E6E6

  .content {
    min-height calc(100vh - 125px)
    background-color white
    padding 10px
    display grid
    grid-template-areas 'drops drops' 'subsread jourread' 'analysis analysis'
    gap 20px
    grid-template-columns 1fr 1fr
    grid-template-rows auto minmax(500px, 1fr) auto

    .dropdowns {
      grid-area drops
    }

    .analysis {
      grid-area analysis
    }
  }
}

@media only screen and (max-width: 1024px) {
  .content {
    grid-template-areas 'drops' 'subsread' 'jourread' 'analysis' !important
    grid-template-columns 1fr !important
    grid-template-rows 130px 500px 500px 1fr !important
  }
}
</style>
